import React from 'react';

export const FormColumn: React.FC<{ size: number }> = ({ size, children }) => {
	return <div className={`size-${size}`}>{children}</div>;
};
export const FormRow: React.FC = ({ children }) => {
	return <div className="form-row">{children}</div>;
};
